import { Button } from 'gf-ui-components-mui-lib';

interface IExportBtn {
  onClick?: any;
  children?: any;
  startIcon?: any;
  isSmallScreen?: boolean;
  boxShadow?: any;
  background?: any;
  color?: any;
  backgroundColor?: any;
  fontColor?: any;
  height?: string;
  access?: any;
  className?: string;
}

export const ExportBtn = ({
  onClick,
  children,
  startIcon,
  isSmallScreen,
  boxShadow,
  background,
  color,
  backgroundColor,
  fontColor,
  height, 
  className
}: IExportBtn) => {
  return (
    <>
      <Button
        sx={{
          fontSize: isSmallScreen ? '12px' : '16px',
          fontWeight: 600,
          backgroundColor: backgroundColor ? backgroundColor : '#FFFFFF !important',
          color: fontColor ? fontColor : '#333333 !important',
          padding: '12px 32px',
          gap: '8px',
          borderRadius: '4px',
          height: height,
          '&:hover': {
            boxShadow: boxShadow ? boxShadow : '0px 2px 12px rgba(0, 0, 0, 0.15)',
            background: `${background ? background : '#fff'} !important`,
            color: `${color ? color : ''} !important`
          },
          '& .MuiButton-startIcon': {
            margin: '0px'
          },
          lineHeight: '32px',
          fontFamily: 'Poppins'
        }}
        id="export-btn"
        startIcon={startIcon}
        onClick={onClick}
        children={children}
        className={className}
      />
    </>
  );
};

export default ExportBtn;
